import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.5 2C4.22386 2 4 2.22386 4 2.5C4 2.77614 4.22386 3 4.5 3H13V11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5V2.5C14 2.22386 13.7761 2 13.5 2H4.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 14H12V4H2V14ZM11 5V13H3V5H11Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }